if ($("#review").length) {
  $wrapper.on("click", ".badge", function (e) {
    $(this).prev().trigger("click");
  });
}
if ($(".review-request").length) {
  $wrapper.find(".t .review-request").one("click", function (e) {
    e.preventDefault();
    var $parent = $(this).parents(".t");
    let $button = $(this);
    let url = $button.attr("href");
    $button.find(".loader").removeClass("hidden");
    window
      .fetch(url, {
        method: "PATCH", // *GET, POST, PUT, DELETE, etc.
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((res) => res.json())
      .then(
        (result) => {
          console.log(result);
          $button.html($button.data("sent")).removeClass("third");
          $button.find(".loader").remove();
        },
        (error) => {
          console.log(error);
          $button
            .html($button.data("error"))
            .removeClass("third")
            .addClass("error");
          setTimeout(function () {
            $button.fadeOut("500");
            setTimeout(function () {
              $button.remove();
            }, 550);
          }, 3000);
        }
      );
    $(this).on("click", function (e) {
      e.preventDefault();
    });
  });

  $wrapper.on("click", ".t .delete", function (e) {
    e.preventDefault();
    var $parent = $(this).parents(".t");

    let url = $(this).attr("href");
    window
      .fetch(url, {
        method: "DELETE", // *GET, POST, PUT, DELETE, etc.
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((res) => res.json())
      .then(
        (result) => {
          // console.log(result)
          $parent.remove();
        },
        (error) => {
          console.log(error);
        }
      );
  });
}
